import React from 'react';

import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import Loading from '../../../../Dashboards/Common/Loading';
import { ServicesPerYearTotal } from '../../../Common/Services/charts/apex-charts/ServicesPerYearTotal';
import { ServicesPerMonthPerYearCompare } from '../../../Common/Services/charts/apex-charts/ServicesPerMonthPerYearCompare';
import ServicesChartsDataProvider from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { subtitlesMap } from '../../Common/maps/subtitleMap';

const GeneralResults = () => {
    const { isLoading, module, queryConfig } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="charts-side-by-side-dashboards">
            <ServicesChartsDataProvider
                module={module}
                queryConfig={queryConfig}
                subtitlesMap={subtitlesMap}
                ignoreMonth
            >
                <ServicesPerYearTotal height={400} />
            </ServicesChartsDataProvider>
            <ServicesPerMonthPerYearCompare />
        </div>
    );
};

export default GeneralResults;
